"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertInlineSize = exports.AlertInlineColor = void 0;
var AlertInlineColor;
(function (AlertInlineColor) {
    AlertInlineColor["Notification"] = "notification-strong";
    AlertInlineColor["NotificationLight"] = "notification-light";
    AlertInlineColor["Alert"] = "alert-strong";
    AlertInlineColor["AlertLight"] = "alert-light";
    AlertInlineColor["Success"] = "success";
    AlertInlineColor["SuccessLight"] = "success-light";
    AlertInlineColor["Fail"] = "fail";
    AlertInlineColor["FailLight"] = "fail-light";
})(AlertInlineColor = exports.AlertInlineColor || (exports.AlertInlineColor = {}));
var AlertInlineSize;
(function (AlertInlineSize) {
    AlertInlineSize["Compact"] = "small";
    AlertInlineSize["Default"] = "medium";
})(AlertInlineSize = exports.AlertInlineSize || (exports.AlertInlineSize = {}));
//# sourceMappingURL=AlertInline.types.js.map